import React from 'react';

const ShimmerTableCol = () => <div className="shimmer shimmer-table-col" />;

export default ShimmerTableCol;
